import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import OrderRequestStatusCell from './OrderRequestStatusCell';
import { INVENTORY_REQUEST_DETAIL_UI } from '../../../util/constants';
import { shouldShowSubmissionInFlight } from '../../../util/submissionStatus';

interface Props {
  children?: React.ReactNode;
  item?: Record<string, any>;
  type?: string | null;
}

// The submission status for every row is fetched once per list by the parent
// (InventoryRequestDataTable) via getSubmissionStatusesByCases and enriched onto each item as
// submissionStatusRecord, so this cell runs no per-row query/poll and no longer gates on
// eventStatus (the in-flight badge shows for any case with an in-flight submission).
const SubmissionStatusCell: FC<Props> = ({ item = {}, type = null }) => {
  const statusByCase = item?.submissionStatusRecord ?? null;
  const rawStatus = statusByCase?.status ?? null;
  const isSubmissionInFlight = shouldShowSubmissionInFlight(
    statusByCase,
    INVENTORY_REQUEST_DETAIL_UI.SUBMISSION_RECOVERY_MAX_AGE_MS
  );

  return (
    <OrderRequestStatusCell
      item={{ ...item, submissionStatus: rawStatus }}
      type={type || undefined}
      isSubmissionInFlight={isSubmissionInFlight}
    />
  );
};

SubmissionStatusCell.displayName = DataTableCell.displayName;

export default SubmissionStatusCell;
